import { render, staticRenderFns } from "./LoginClaim.vue?vue&type=template&id=1c395ce7&scoped=true&"
import script from "./LoginClaim.vue?vue&type=script&lang=js&"
export * from "./LoginClaim.vue?vue&type=script&lang=js&"
import style0 from "./LoginClaim.vue?vue&type=style&index=0&id=1c395ce7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c395ce7",
  null
  
)

export default component.exports